import { FC } from "react";
import { useQuery } from "react-query";
import { Button, Space } from "antd";

import { API } from "../../api";
import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { MyMarkdown } from "../MyMarkdown";

export const InstructionBlock: FC = () => {
  const { clean, cancelDrawer } = useStore();
  const { object_id } = clean as IClean;
  const { data } = useQuery("insctruction", () => API.getInstruction(object_id));
  if (!data) return null;
  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <MyMarkdown text={data.text} />
      {/* <div className="content">{data.text}</div> */}
      <Button onClick={cancelDrawer} block size="large">
        Закрыть
      </Button>
    </Space>
  );
};
